module.exports = __webpack_public_path__ + "img/txt_info3.3ad77173.png";